import CouvertSettings from './CouvertSettings';

export default CouvertSettings;
